<template>
    <v-container>
        <v-card elevation="-1" outlined>
            <v-card-title class="text-h4">Notifications</v-card-title>
            <v-card-text style="padding-bottom:0px;">
                Notifications provide updates on transactions actions. To save a notification for later star the
                message, otherwise the notification will be removed after it has been read.
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <div class="float-right">
                    <v-tabs v-model="tabSelection"
                        :color="($vuetify.theme.dark) ? 'var(--darkColor)' : 'var(--lightColor)'">
                        <v-tab>New</v-tab>
                        <v-tab>All</v-tab>
                        <v-tab>Starred</v-tab>
                    </v-tabs>
                </div>

            </v-card-actions>

            <v-container>
                <!-- New -->
                <div v-if="getAllMessages != null">
                    <div v-for="(notification, index) in getAllMessages" :key="index">
                        <NotificationCard class="pb-3" :tabSelection="tabSelection" :id="notification.id"
                            :title="notification.title" :message="notification.message" :passDate="notification.date"
                            v-bind:passStatus="notification.status" v-bind:passStarred="notification.starred">
                        </NotificationCard>
                    </div>
                </div>
            </v-container>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import accessHelper from '@/mixins/accessHelper';
import NotificationCard from '@/components/NotificationCard.vue';

export default {
    name: "NotificationsPage",

    props: {
    },

    mixins: [accessHelper],
    components: {
        NotificationCard
    },
    data: () => ({
        tabSelection: 0,
    }),
    computed: {
        ...mapGetters([
            "getAccount",
            "getSites",
            'getAllMessages',
        ]),
    },
    mounted() {
        this.getMessages();
    },
    methods: {
        ...mapActions([
            'fetchAccount',
            'fetchAccountBalance',
            'fetchSites',
            'fetchAllMessages'
        ]),

        async getMessages() {
            // Only get all the messages from the notifications page. 
            this.fetchAllMessages();
        },
    },
}
</script>

<style scoped></style>